import React, { useEffect, useRef } from "react";
import "../ui/tokens.css";
import "./guest.css";

export const ACCOUNT_BENEFITS = [
  "Your chats saved, grouped by day and searchable",
  "My tasks: small steps you can check off",
  "Lock-In: focus sessions with calm sound",
  "Download or delete your data any time",
];

// Shown when the guest demo runs out of time or messages. Lists what a free account adds.
export default function GuestEnded({ reason, onCreateAccount, onBack }) {
  const primary = useRef(null);
  useEffect(() => {
    if (primary.current) primary.current.focus();
  }, []);

  const title = reason === "messages" ? "You've reached the demo limit" : "Your demo has ended";
  return (
    <div className="gd-overlay" role="dialog" aria-modal="true" aria-labelledby="gd-title">
      <div className="gd-card">
        <h2 id="gd-title" className="gd-title">{title}</h2>
        <p className="gd-sub">Thanks for trying Rigby. A free account adds:</p>
        <ul className="gd-list">
          {ACCOUNT_BENEFITS.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
        <button ref={primary} type="button" className="gd-primary" onClick={onCreateAccount}>
          Create free account
        </button>
        <button type="button" className="gd-ghost" onClick={onBack}>
          Back to start
        </button>
        <p className="gd-fine">If you're struggling right now, call or text 988 (U.S.) or call 911 in an emergency.</p>
      </div>
    </div>
  );
}
